// dependancy in this case just refers to toggling of the required field
const toggleRequired = (checked, dependantField) => {
  const label = dependantField.parentNode.querySelector('label'),
        labelTxt = label.innerHTML.split('<')[0];

  if (checked) {
    dependantField.setAttribute('aria-required', true);
    dependantField.setAttribute('required', true);

    label.innerHTML = `${labelTxt} <span class="is-text-red">*</span>`;
    return true;
  } else {
    dependantField.removeAttribute('aria-required');
    dependantField.removeAttribute('required');

    label.innerHTML = `${labelTxt}`;
  }
}

const watchForFormDependancies = () => {
  const hasDependancies = Array.from(document.querySelectorAll('[data-has-dependancy]'));

  if (hasDependancies.length > 0) {
    hasDependancies.forEach((field) => {
      const dependantField = document.getElementById(field.dataset.hasDependancy);

      if (field.type == 'radio') {
        const group = Array.from(document.querySelectorAll(`[name="${field.name}"]`));

        group.forEach((option) => {
          option.onchange = () => {
            toggleRequired(option == field, dependantField);
          }
        })
      }
    });
  }
}

export default watchForFormDependancies;


// WEBPACK FOOTER //
// ./src/js/components/form-dependancies.js